import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation updateEventRsvp($id: String!, $status: UpdateEventRsvpStatus!) {
    updateEventRsvp(groupEventId: $id, status: $status) {
      success
      message
    }
  }
`

export interface UpdateEventRsvpInput {
  id: string
  status: "going" | "notGoing" | "maybe"
}

export interface UpdateEventRsvpOutput {
  updateEventRsvp: {
    success: boolean
    message: string
  }
}

export const useUpdateEventRsvp = () => useMutation<UpdateEventRsvpOutput, UpdateEventRsvpInput>(mutation)
